/**
 * Pure helpers for the task Actions list ordering, mirroring the Android
 * ActionData reorder contract (actionOrder is a 0-based ascending index).
 * Kept side-effect-free so they can be unit-tested without Firebase or DnD.
 */

/**
 * The actionOrder to give a newly-added action: one past the current max,
 * matching Android's AddAction (`(maxOrder ?: 0) + 1`). Appends at the end.
 */
export function nextActionOrder(list) {
  const max = list.reduce(
    (m, a) => (typeof a.actionOrder === "number" && a.actionOrder > m ? a.actionOrder : m),
    0
  );
  return max + 1;
}

/** Return a new array with the item at fromIndex moved to toIndex. */
export function moveItem(list, fromIndex, toIndex) {
  const next = [...list];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
}

/**
 * Given a list already in its desired visual order, return the minimal set of
 * { id, actionOrder } writes needed so every row's stored actionOrder matches
 * its position. Only rows whose actionOrder actually changed are returned, so
 * callers issue the fewest Firestore writes (matches Android's reindex, which
 * only flips changed siblings to remoteState=upload).
 */
export function computeReindexUpdates(list) {
  const updates = [];
  list.forEach((action, index) => {
    if (action.actionOrder !== index) {
      updates.push({ id: action.id, actionOrder: index });
    }
  });
  return updates;
}
